export function formatTime(time,type) {
  if(time){
    const dateTime = new Date(time);
    const YY = dateTime.getFullYear();
    const MM =
      dateTime.getMonth() + 1 < 10
        ? '0' + (dateTime.getMonth() + 1)
        : dateTime.getMonth() + 1;
    const D =
      dateTime.getDate() < 10 ? '0' + dateTime.getDate() : dateTime.getDate();
    const hh =
      dateTime.getHours() < 10
        ? '0' + dateTime.getHours()
        : dateTime.getHours();
    const mm =
      dateTime.getMinutes() < 10
        ? '0' + dateTime.getMinutes()
        : dateTime.getMinutes();
    const ss =
      dateTime.getSeconds() < 10
        ? '0' + dateTime.getSeconds()
        : dateTime.getSeconds();
    if(type=='d'){
      return `${YY}-${MM}-${D}`;
    }else if(type=='h'){
      return `${YY}-${MM}-${D} ${hh}`;
    }else if(type=='m'){
      return `${YY}-${MM}-${D} ${hh}:${mm}`;
    }else if(type=='s'){
      return `${YY}-${MM}-${D} ${hh}:${mm}:${ss}`;
    }else {
      return `${YY}-${MM}-${D}`;
    }
  }
}

export function formatStatus(status){
  if(status){
    if(status=='release'){
      return '已发布';
    }else if(status=='wait'){
      return '待审核';
    }else if(status=='unpass'){
      return '未通过';
    }else if(status=='revoke'){
      return '已撤销';
    }
  }
}

export function formatStatusEn(status){
  if(status){
    if(status=='release'){
      return 'Release';
    }else if(status=='wait'){
      return 'Approved';
    }else if(status=='unpass'){
      return 'Not pass';
    }else if(status=='revoke'){
      return 'Undone';
    }
  }
}

export function splitWords(words){
  var str = '';
  if(words){
    const start = '<span style="background:#522e95;font-size:14px;margin-right:10px;color:#fff;padding:0 10px;border-radius:2px;">';
    const end = '</span>';
    const array = words.split('#%');
    if(array){
      for(var i=0;i<array.length;i++){
        str = str + start + array[i] + end;
      }
    }
  }
  return str;
}

export function splitWords_length(words,length){
  var str = '';
  if(words){
    const start = '<span style="background:#522e95;font-size:14px;margin-right:10px;color:#fff;padding:0 10px;border-radius:2px;">';
    const end = '</span>';
    const array = words.split('#%');
    if(array){
      var maxl = 0;
      if(array.length>length){
        maxl = length;
      }else{
        maxl = array.length;
      }
      for(var i=0;i<maxl;i++){
        str = str + start + array[i] + end;
      }
    }
  }
  return str;
}

export function cutWords(words,length){

  var str = words;
  if(words && words.length>length){
    str = words.substring(0,length-1) + '...';
  }
  return str;
}

export function splitName(name){
  var str = '';
  if(name){
    const array = name.split('');
    if(array){
        str = array[0]
      }
  }
  return str;
}
